import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import { removeClientKey } from "~/actions/clients.js"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import React, { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import serialize from "~/store/serialize"

import useStyles from "./styles"
const SimpleConfirmDialog = () => {
  const classes = useStyles()
  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const thisDialog = dialogs?.["confirmDialog"] || {}
  const { open = false, data } = thisDialog
  const openErrorSnackbar = useOpenErrorSnackbar()
  let title = data?.title || "Confirm"
  let message = data?.message || "Are you sure that you want to delete this?"
  let confirmDelete = data?.confirmDelete
  const queryClient = useQueryClient()

  const handleClose = () => {
    closeDialog("confirmDialog", false)
  }
  // refactored clients keys delete logic to be passed in through dialog - keep the dialog simple
  return (
    <Dialog classes={{ paperWidthSm: classes.dialogMinHeight }} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions
        style={{
          position: "absolute",
          bottom: 4,
          right: 16,
        }}
      >
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => confirmDelete()}
          variant="contained"
          color="secondary"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SimpleConfirmDialog.propTypes = {}

export default SimpleConfirmDialog
